export default {
    logo: require('@/assets/img/logo.svg'),
    strings: {
        idle: 'Чтобы посетить музей, пожалуйста, отсканируйте ваш сертификат вакцинации:',
        idleCamera: 'Чтобы посетить музей, пожалуйста, отсканируйте ваш сертификат вакцинации:',
        idleHandheld_notFocused: 'Подключён внешний сканер. Перед сканированием нажмите на поле ниже:',
        idleHandheld: 'Внешний сканер готов к использованию.',
        scanSuccess: 'Сертификат действителен. Проходите!',
        loading: 'Загружаем данные...',
        scanFail: 'Такого сертификата нет в системе.',
        scanFail_expired: 'Срок действия сертификата истёк.',
        scanFail_fraud: 'Это поддельный QR-код. Не надо так.',
        scanFail_domain: 'QR-код содержит неверный домен: %s',
        scanError: 'Произошла ошибка :('
    },
    colors: {
        idle: {
            background: '#fff4e2',
            text: '#363636'
        },
        scanSuccess: {
            background: '#A9FFCB',
            text: '#228756'
        },
        scanFail: {
            background: '#FFDDDB',
            text: '#FF363D'
        },
        accent: '#364FEF'
    }
}
